import React, { useEffect, useMemo } from 'react';

import { useState } from 'react';

import {
  defaultProvider,
  getBuyTokenContract,
  getContractABIBuy,
  getContractBuyAddress
} from '../helpers/web3utils';
import { useAccount, useWalletClient, useWriteContract } from 'wagmi';
import { ethers, getDefaultProvider } from 'ethers';
import { BrowserProvider } from 'ethers';

import { WalletClient } from 'viem';
import { useWeb3ModalProvider } from '@web3modal/ethers/react';
import toast from '../libs/toast';
import clsx from 'clsx';
import { RefCode } from '../helpers';
import useWalletConnect from '../hooks/useWalletConnect';
import ProgressBar from '@ramonak/react-progress-bar';
import '../custom.css';
import { useInterval } from '../hooks/useInterval';
import useRefCode from '../hooks/useRefCode';
import {
  useCanClaimPercent,
  useClaimToken,
  useTotalBuy,
  useTotalTokenClaim
} from '../hooks/useContract';
const clientToProviderSigner = async (client) => {
  console.log(client);
  const { account, chain, transport } = client;
  const network = {
    chainId: chain?.id,
    name: chain?.name,
    ensAddress: chain?.contracts?.ensRegistry?.address
  };
  // You can use whatever provider that fits your need here.
  const provider = new BrowserProvider(client);
  const signer = await provider.getSigner(account?.address);
  console.log(signer);
  return { provider, signer };
};

const Allocation = ({ setT }) => {
  const { address, isConnected } = useAccount();
  const { data: dataCanClaimPercent } = useCanClaimPercent();
  const { data: dataTotalBuy, refetch } = useTotalBuy(address);

  const { data: dataTotalClaim, refetch: refetch2 } = useTotalTokenClaim(address);
  const canClaim = useMemo(() => {
    return Number(
      ethers.formatEther(
        (BigInt(dataTotalBuy || 0) * BigInt(dataCanClaimPercent || 0)) / BigInt(100) -
          BigInt(dataTotalClaim || 0)
      )
    );
  }, [dataCanClaimPercent, dataTotalClaim, dataTotalBuy]);
  console.log(dataCanClaimPercent, dataTotalClaim, dataTotalBuy);
  
  const [balance, setBalance] = useState(0);
  const [amountBNB, setAmountBNB] = useState('0');
  const [amountToken, setAmountToken] = useState(0);
  const [buyTokenContract, setBuyTokenContract] = useState(null);
  const [currentPrice, setCurrentPrice] = useState(0);
  const [totalPurchased, setTotalPurchases] = useState(0);
  const [currentBlockInfo, setCurrentBlockInfo] = useState({
    totalInNumber: 0,
    amountInNumber: 0,
    currentPercent: 0,
    currentBlock: 0
  });
  const { isPending, handleClaim } = useClaimToken(() => {
    refetch2();
    refetch();
  });
  const { data: walletClient } = useWalletClient();
  const { walletProvider } = useWeb3ModalProvider();

  useInterval(() => {
    getStatus();
  }, 10000);

  const connectWallet = async () => {
    if (!walletProvider) return;
    const { signer, provider } = await clientToProviderSigner(walletProvider);
    // Do whatever you want with the provider and signer like storing them in a state or context
  };
  useEffect(() => {
    // Finally we only want to get a provider if the user is connected(from the modal) AND there's a wallet client
    isConnected && walletClient && connectWallet();
  }, [isConnected, walletClient]);

  useEffect(() => {
    if (isConnected) {
      getBNBBalance();
    } else {
      setBalance(0);
    }
  }, [isConnected]);
  useEffect(() => {
    if (address && isConnected && buyTokenContract) {
      getTotalPurchased();
    }
  }, [isConnected, buyTokenContract]);
  useEffect(() => {
    if (amountBNB != '' && Number(currentPrice) != 0) {
      var totalAIW = Number(amountBNB) / Number(currentPrice);
      setAmountToken(totalAIW);
    } else {
      setAmountToken(0);
    }
  }, [amountBNB]);
  useEffect(() => {
    getStatus();
  }, []);
  const getStatus = async () => {
    var contract = getBuyTokenContract();
    setBuyTokenContract(contract);
    contract = contract.connect(defaultProvider());
    /* global BigInt */
    contract.getCurrentPrice(BigInt(0)).then((price) => {
      setCurrentPrice(ethers.formatEther(price));
    });
    const totalSale = await contract.totalSale();
    const blocks = await contract.getBlocks();
    const amounts = blocks._amounts;
    var total = BigInt('0');
    for (var i = 0; i < amounts.length; i++) {
      const tmp = total + amounts[i];
      if (totalSale < tmp) {
        const currentBlockSale = totalSale - total;
        const amountInNumber = Number(ethers.formatEther(amounts[i]));
        const totalInNumber = Number(ethers.formatEther(currentBlockSale));
        const currentPercent = (totalInNumber / amountInNumber) * 100;
        const currentBlock = i + 1;
        setCurrentBlockInfo({
          totalInNumber,
          amountInNumber,
          currentBlock,
          currentPercent
        });
        break;
      }
      total = tmp;
    }
  };
  const getTotalPurchased = async () => {
    var contract = buyTokenContract.connect(defaultProvider());
    await contract.totalBuy(address).then((totalBuy) => {
      setTotalPurchases(ethers.formatEther(totalBuy));
    });
  };
  const getBNBBalance = async () => {
    const tmpBalance = await defaultProvider().getBalance(address);
    setBalance(ethers.formatEther(tmpBalance));
  };
  // const handleBuy = async () => {
  //   // writeContract()
  //   try {
  //     if (!isConnected) {
  //       openConnectWallet();
  //       return;
  //     }
  //     if (!refCode) {
  //       toast.error('Referral code required.');
  //       return;
  //     }
  //     if (refCode === address) {
  //       toast.error('You cannot referral yourself.');
  //       return;
  //     }
  //     setIsLoading(true);
  //     // const { signer, provider } = await clientToProviderSigner(walletProvider);
  //     if (!Number(amountBNB) || !Number(amountToken) || Number(amountBNB) <= 0) {
  //       toast.error('Please fill in the amount BNB');
  //       setIsLoading(false);
  //     } else {
  //       const contract = getBuyTokenContract(defaultProvider());
  //       const totalBuy = await contract.totalBuyBNB(address);
  //       if (Number(ethers.formatEther(totalBuy)) + Number(amountBNB) >= 3) {
  //         toast.error('Each wallet can purchase a maximum of 3 BNB.');
  //         setIsLoading(false);
  //         return;
  //       }

  //       // const options = {
  //       //   value:
  //       //     (ethers.parseEther(amountToken.toString()) *
  //       //       ethers.parseEther(currentPrice.toString())) /
  //       //     ethers.parseEther('1')
  //       // };

  //       toast
  //         .promise(async () => {
  //           // contract.buyToken(
  //           //   refCode && refCode !== address && ethers.isAddress(refCode)
  //           //     ? refCode
  //           //     : ethers.ZeroAddress,
  //           //   ethers.parseEther(amountToken.toString()),
  //           //   options
  //           // )
  //           return writeContractAsync({
  //             abi: getContractABIBuy(),
  //             address: getContractBuyAddress(),
  //             functionName: 'buyToken',
  //             args: [
  //               refCode && refCode !== address && ethers.isAddress(refCode)
  //                 ? refCode
  //                 : ethers.ZeroAddress,
  //               ethers.parseEther(amountToken.toString())
  //             ],
  //             value:
  //               (ethers.parseEther(amountToken.toString()) *
  //                 ethers.parseEther(currentPrice.toString())) /
  //               ethers.parseEther('1')
  //           });
  //         })
  //         .then(async (res) => {
  //           setAmount(0);
  //           setT((prev) => !prev);
  //           await getBNBBalance();
  //           await getTotalPurchased();
  //           getStatus();
  //           setIsLoading(false);
  //         })
  //         .catch((e) => {
  //           setIsLoading(false);
  //         });
  //     }
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoading(false);
  //   }
  // };

  const currentPercentFixed = currentBlockInfo.currentPercent.toFixed(2);
  return (
    <>
      {currentBlockInfo.currentBlock > 1 ? (
        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: '20px'
          }}
        >
          {' '}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
            <span>Price: {Number(currentPrice)} BNB</span>
          </div>
          <div class="p-sale-progress" style={{ marginBottom: 0 }}>
            <p
              style={{
                textAlign: 'right'
              }}
            >
              AIW sold:{' '}
              <span
                style={{
                  background: 'linear-gradient(to right, #49ff87, #047e35)',
                  '-webkit-background-clip': 'text',
                  '-webkit-text-fill-color': 'transparent'
                }}
              >
                {Number(currentBlockInfo.totalInNumber).toFixed(1)}
              </span>{' '}
              /{currentBlockInfo.amountInNumber}
            </p>
          </div>
        </div>
      ) : (
        <>
          {' '}
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'end' }}>
            {/* <span>
          Block:{' '}
          <span className="p-presale-area__sub" style={{ fontSize: '1.4rem' }}>
            {currentBlockInfo.currentBlock}
          </span>{' '}
          / 10
        </span> */}
            <span>Price: {Number(currentPrice)} BNB</span>
          </div>
          <div class="p-sale-progress">
            <div class="p-sale-progress__bar">
              <p class="p-sale-progress__txt">{currentPercentFixed}% complete</p>
              <p class="p-sale-progress__bg" style={{ width: currentPercentFixed + '%' }}></p>
            </div>
            <p
              style={{
                textAlign: 'right'
              }}
            >
              AIW sold:{' '}
              <span
                style={{
                  background: 'linear-gradient(to right, #49ff87, #047e35)',
                  '-webkit-background-clip': 'text',
                  '-webkit-text-fill-color': 'transparent'
                }}
              >
                {Number(currentBlockInfo.totalInNumber).toFixed(1)}
              </span>{' '}
              /{currentBlockInfo.amountInNumber}
            </p>
          </div>
        </>
      )}

      <div className="tab-box" data-id="allocation">
        <p className="p-presale-body__ttl">Allocation</p>
        <div className="p-presale-row">
          <div className="p-presale-row__item --haft">
            <p className="p-presale-body__txt">
              Buy AIW and share your code to get additional rewards.
            </p>
          </div>
          <div className="p-presale-row__item --shrink">
            <p className="p-presale-row__txt">You purchased:</p>
            <p className="p-presale-row__ttl">{Number(totalPurchased).toFixed(1)} AIW</p>
          </div>
        </div>
        <div className="p-presale-area" style={{ borderRadius: '1rem' }}>
          <div className="p-presale-area__item" style={{ marginBottom: 0 }}>
            <p className="p-presale-area__sub">Can claim AIW</p>
            {/* <p className="p-presale-area__balance">Balance: {Number(balance).toFixed(4)} BNB</p> */}
          </div>
          <input
            value={canClaim}
            lang="en-US"
      
            onKeyDown={(e) => {
              const key = e.key;
              if (
                // key === ',' || // comma
                key === '.' || // comma
                key === 'Backspace' || // backspace
                key === 'Tab' || // tab
                key === 'Escape' || // escape
                key === 'Enter' || // enter
                key === 'Home' || // home
                key === 'End' || // end
                key === 'ArrowLeft' || // left arrow
                key === 'ArrowRight' // right arrow
              ) {
                return;
              }

              // Ensure that it is a number
              if (!/^[0-9]$/.test(key)) {
                e.preventDefault();
              }
            }}
            className=" p-presale-copy__txt"
            // onChange={(e) => setAmountBNB(e.target.value)}
            disabled
            style={{ border: 'none', fontSize: 16, fontStyle: 'none' }}
          ></input>
          {/* <div className="p-presale-area__bottom">
            <div className="p-presale-area__bottom-wrap">
              <div className="p-presale-area__btn">
                <div className="item --number" style={{ cursor: 'pointer' }}>
                  = {amountToken.toFixed(1)} AIW
                </div>
                <a
                  href="#"
                  onClick={() => {
                    setAmountBNB(Number(balance).toFixed(4));
                  }}
                  className="item --txt"
                >
                  Max: {Number(balance).toFixed(4)} BNB
                </a>
              </div>
            </div>
          </div> */}
        </div>

        {canClaim > 0 ? (
          <div className="p-presale-body__bottom">
            <div className="p-presale-body__bottom-wrap">
              <button
                disabled={isPending}
                className={clsx('p-presale-btn', isPending ? 'disable' : '')}
                onClick={handleClaim}
              >
                Claim AIW
              </button>
            </div>
          </div>
        ) : (
          <></>
        )}
      </div>
    </>
  );
};

export default Allocation;
